import { styled } from "@vitality-ds/system";
import baseTypographyStyles from "./styles/BaseTypography.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseTypography = styled("span", baseTypographyStyles);